module.exports = __webpack_public_path__ + "img/3-11-1.307cb98f.png";